import { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import Select from "react-select";
import ReactPaginate from "react-paginate";
import moment from "moment";
import { selector } from "../../../api";
import { Footer } from "../../../layout/footer"
import { options } from "../../../api";
import { kayaCRUD } from "../../../actions/kaya"
import { Loading } from "../../constant";
import { toast } from "react-toastify";
import { MemberDetail } from "../member/details";

export const MemberDeadContent = () => {

  const user = selector.User()

  const closeRef = useRef();
  
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0)
  const [dataId, setDataId] = useState('')
  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [index, setIndex] = useState(0)

  useEffect(() => {
    setTimeout(() => {
      kayaCRUD.loadKayaMemberDead(postsPerPage, nextPage, value).then((resp) => {
        setCount(resp.data.count)
        setData(resp.data.results)
        setPageCount(Math.ceil(resp.data.count / postsPerPage))
      }).finally(() => {})
    }, 2000)
  }, [page, postsPerPage, value, index])

  const handleChangePage = (event) => {
    setData([])
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = selectedOption => {
    setData([])
    const sel = selectedOption.value;
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0)
  };

  const handleSearch = (event) => {
    setData([])
    setValue(event.target.value)

  }

  const handleReturn = (e) => {
    setLoading(true)
    const data = { dictionary_death_causes: null, death_date: null, is_dead: false, death_detail: null }
    setTimeout(() => {
      kayaCRUD.updateDeadMember(e, data).then(() => {
        toast.success('Member death has been canceled.', { autoClose: 7000 })
        setIndex(index+1)
        setLoading(false)
        closeRef.current.click()
      }).catch((error) => {
        toast.error(error.message, { autoClose: 7000 })
        setLoading(false)
      })
    }, 500)
  }

  const handleChangeId = (e) => {
    setDataId(e)
  }


  return (

    <>
      <MemberDetail dataId={dataId}/>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">

            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Dead House Hold Member</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="#">Member</a></li>
                      <li className="breadcrumb-item active">List</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="d-flex justify-content-sm-start">
                            <div className="search-box ms-2">
                                <input type="text" className="form-control search" value={value} onChange={handleSearch} placeholder="Search by name or phone..."/>
                                <i className="ri-search-line search-icon"></i>
                            </div>
                        </div>
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table id="scroll-vertical" className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th>SR No.</th>
                          <th>Reg Number</th>
                          <th>Full Name</th>
                          <th>Gender</th>
                          <th>Birth Date</th>
                          <th>Death Date</th>
                          <th>Relation to Head</th>
                          <th>Death Cause</th>
                          <th className="d-flex justify-content-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          data?.map((dt, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{dt.member_id.reg_no ? dt.member_id.reg_no : 'N/A'}</td>
                              <td>{dt.member_id.full_name ? (dt.member_id.full_name).toUpperCase() : 'N/A'}</td>
                              <td>{dt.member_id.dictionary_gender ? dt.member_id.dictionary_gender.dictionary_item_name_en : 'N/A'}</td>
                              <td>{moment(dt.member_id.dob).format("D MMM, YYYY")}</td>
                              <td>{moment(dt.member_id.death_date).format("D MMM, YYYY")}</td>
                              <td>{dt.member_id.dictionary_relation_to_head ? dt.member_id.dictionary_relation_to_head.dictionary_item_name_en : 'N/A'}</td>
                              <td>{dt.member_id.dictionary_death_causes ? dt.member_id.dictionary_death_causes.dictionary_item_name_en : 'N/A'}</td>
                              <td className="d-flex justify-content-center">
                                <div className="hstack gap-3 fs-15">
                                <Link to={'#'} onClick={() => handleChangeId(dt.member_id.id)} className="btn btn-sm btn-soft-success" data-bs-toggle="modal" data-bs-target=".detailModal"><i className="bi bi-eye"></i></Link>
                                  <Link to={'#'} onClick={() => handleChangeId(dt.member_id.id)} data-bs-toggle="modal" data-bs-target="#firstmodal" className="btn btn-sm btn-soft-primary" ><i className="bi bi-arrow-up-right-circle"></i></Link>
                                  {dt.kaya_id && dt.kaya_id.kaya_building[0] ?
                                    <Link to={'/map'} state={{type: 'building', id: dt.kaya_id.kaya_building[0].building_id.id}} class="btn btn-sm btn-soft-info"><i class="bi bi-geo-alt"></i></Link>
                                    : <a href="javascript:void(0);" class="btn btn-sm btn-soft-info"><i class="bi bi-geo-alt"></i></a>
                                  }
                                </div>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    <div className="row">
                      {!data.length && <Loading/>}
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <p><span>Showing </span><span>{data.length}</span> of <span>{count}</span> entries</p>
                      </div>
                      <div className="col-md-5">

                      </div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select options={options} defaultValue={options[1]} onChange={handleChange} />
                          </div>
                          <div className="col-auto paginate" >
                            <ReactPaginate
                              previousLabel={<i className="las la-angle-double-left la-lg"></i>}
                              nextLabel={<i className="las la-angle-double-right la-lg"></i>}
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <Footer />
      </div>
        <div class="modal fade" id="firstmodal" aria-hidden="true" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                    
                  <div class="modal-body text-center p-5">
                    <button style={{display: 'none'}} ref={closeRef} type="button" className="close" data-bs-dismiss="modal" aria-label="Close"></button>
                      <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f7b84b,secondary:#405189" style={{width:"130px", height:"130px"}}></lord-icon>
                      <div class="mt-4 pt-4">
                          <h4>Are you sure</h4>
                          <p class="text-muted"> The death transfer was ndone by mistake. the death report wasn't correct.</p>
                          <button class="btn btn-danger" onClick={() => {closeRef.current.click()}} >
                              Close
                          </button>
                          &emsp;
                          <button class="btn btn-success" onClick={() => handleReturn(dataId)} disabled={loading}>
                              {!loading && <span className='indicator-label'>Continue</span>}
                              {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                  Please wait...
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              )}
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </>

  )

}